export default "__VITE_ASSET__CrkTUT0L__"